// extracted by mini-css-extract-plugin
export default {"storyItem":"c-a_fq","storyItem__circle":"c-a_fr","storyItem__image":"c-a_fs","storyItem__description":"c-a_ft","storyItem_viewAll":"c-a_fu"};